<div class="package !flex flex-row justify-start items-center flex-[7%] max-w-[7%]">
  <div class="package-badge {{ subscription.plan.toLowerCase() }}-package-badge">
    {{ subscription.plan }}
  </div>
</div>
<div class="status !flex flex-row justify-start items-center flex-[6%] max-w-[6%]">
  <mat-icon
    *ngIf="subscription.status?.toLowerCase() === subscriptionsStatusType.active"
    [matTooltip]="'+USER_DETAILS.BOOKINGS.STATUS.ACTIVE' | translate"
    class="active-icon"
  >
    check_circle
  </mat-icon>
  <mat-icon
    *ngIf="subscription.status?.toLowerCase() === subscriptionsStatusType.canceled"
    [matTooltip]="'+USER_DETAILS.BOOKINGS.STATUS.CANCELLED' | translate"
    class="cancelled-icon"
  >
    cancel
  </mat-icon>
  <mat-icon
    *ngIf="subscription.status?.toLowerCase() === subscriptionsStatusType.expired"
    [matTooltip]="'+USER_DETAILS.BOOKINGS.STATUS.EXPIRED' | translate"
    class="expired-icon"
  >
    radio_button_unchecked
  </mat-icon>
</div>
<div class="device !flex flex-row justify-start items-center flex-[20%] max-w-[20%]">
  <p>{{ subscription.boilerId }}</p>
</div>
<div class="owner !flex flex-row justify-start items-center flex-[25%] max-w-[25%]">
  <p>
    {{ subscription.ownerName }} <br />
    {{ subscription.installationLocation }}
  </p>
</div>
<div class="details !flex flex-row justify-start items-center flex-[35%] max-w-[35%]">
  <div class="flex flex-row">
    <vi-item
      data-at-user-type-details
      size="medium"
      title="{{ '+USER_DETAILS.BOOKINGS.BOOKING_DATE' | translate }}"
      [value]="subscription.subscriptionDate | date"
    ></vi-item>
    <vi-item
      data-at-user-type-details
      size="medium"
      [title]="title | translate"
      [value]="subscription.expirationDate | date"
    ></vi-item>
    <vi-item
      *ngIf="subscription.status?.toLowerCase() === subscriptionsStatusType.canceled"
      data-at-user-type-details
      size="medium"
      title="{{ '+BOOKING.OVERVIEW.SUBSCRIPTION.DURATION' | translate }}"
      [value]="leftDays"
    ></vi-item>
    <vi-item
      data-at-user-type-details
      size="medium"
      title="{{ '+BOOKING.OVERVIEW.SUBSCRIPTION.BOOKING_FROM' | translate }}"
      [value]="subscription.subscribedByName"
    ></vi-item>
  </div>
</div>
<div class="trial !flex flex-row justify-start items-center flex-[6%] max-w-[6%]">
  <app-pill [type]="pillType.success" *ngIf="subscription.trial">{{
    '+USER_DETAILS.BOOKINGS.TRIAL_BADGE' | translate
  }}</app-pill>
</div>
<div class="menu !flex flex-row justify-start items-center flex-[6%] max-w-[6%]">
  <ng-container *ngIf="isCancelMenuVisible">
    <button mat-button [matMenuTriggerFor]="menu">
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
      <button
        mat-menu-item
        appCancelBooking
        gtm="onOpen"
        gtmAction="Cancel booking"
        gtmCategory="userDetails"
        [boilerId]="subscription.boilerId"
        [companyId]="userDetailsStore.companyNumber$ | async"
        [subscriptionPlan]="subscription.plan"
      >
        {{ '+USER_DETAILS.BOOKINGS.CANCEL_BOOKING_MODAL.BUTTON.CANCEL_BOOKING' | translate }}
      </button>
    </mat-menu>
  </ng-container>
</div>
